export const CORRELATION_ID_HEADER = "X-Correlation-ID";

function createCorrelationId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID().replace(/-/g, "");
  }

  return `corr${Date.now().toString(16)}${Math.random().toString(16).slice(2, 10)}`;
}

export function createRequestCorrelationId() {
  return createCorrelationId();
}

export function buildCorrelationHeaders() {
  return {
    [CORRELATION_ID_HEADER]: createRequestCorrelationId(),
  };
}
